import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

export function getSharedLink<T extends Record<K, { value?: unknown }>, K extends keyof T>(
  fields: T,
  fieldName: K
): LinkField | undefined {
  const localizedLinkField = fields?.[fieldName] as LinkField;
  const isLocalizedLinkSpecified: boolean = !!localizedLinkField?.value?.href;
  if (isLocalizedLinkSpecified) {
    return localizedLinkField;
  }

  const sharedString = `${fieldName as String}Shared` as keyof T;
  const sharedLink = fields?.[sharedString] as LinkField;
  const isSharedLinkSpecified: boolean = !!sharedLink?.value?.href;
  return isSharedLinkSpecified ? sharedLink : undefined;
}

export const isBooleanField = (field: Field | any): field is Field<'False' | 'True'> => {
  return (
    typeof field === 'object' &&
    !!field &&
    typeof field.value === 'string' &&
    ['False', 'True'].includes(field.value)
  );
};
